/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ITiposBodegas from 'Infotrack@Modelos/smartStock/tiposBodegas/entidades/tiposBodegas';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import TiposBodegasCM from '../controladorModelo/tiposBodegasCM';
import { acciones, IEstadoTiposBodegas } from '../reductorTiposBodegas';
import TiposBodegasVista from '../vista/tablaTiposBodegasVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const tiposBodegasCM = new TiposBodegasCM();

const TableTiposBodegasCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [tiposBodegass, setTiposBodegass] = React.useState<ITiposBodegas[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoTiposBodegas>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarTiposBodegas();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarTiposBodegas = () => {
        manejadorIndicadorCargaGlobal(true);
        tiposBodegasCM.consultarTiposBodegasPorFiltro({EmpresaId:idEmpresa}).then((tiposBodegass) => {
            setTiposBodegass(modificarPropiedadesTiposBodegas(tiposBodegass));
            manejadorIndicadorCargaGlobal(false);
        });
    };

    const modificarPropiedadesTiposBodegas = (tiposBodegas: ITiposBodegas[]) => {
        return tiposBodegas.map((tipoBodega) => ({
            ...tipoBodega,
            Estado: tipoBodega.Estado !== 1 ? 0 : tipoBodega.Estado,
        }));
    };

    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadTiposBodegas?: ITiposBodegas) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadTiposBodegas, tipoFormulario } });
    };

    const confirmarEliminacion = (tiposBodegas: ITiposBodegas) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarTiposBodegas(tiposBodegas),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarTiposBodegas = (tiposBodegas: ITiposBodegas) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        tiposBodegasCM.eliminarTiposBodegas(tiposBodegas).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <TiposBodegasVista
            tiposBodegass={tiposBodegass}
            cargarTiposBodegas={cargarTiposBodegas}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableTiposBodegasCV;
